import { Injectable } from '@angular/core';
import { ISite } from 'src/app/models/site.model';
import { Provider } from '../provider';

@Injectable()
export class EventSiteService extends Provider<ISite>{
  protected url = "events/sites";
}
